import { getAPIBaseURL } from './helpers'
import { getData, postData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')
  return token ? { token } : {}
}

export const listMyDisputes = async () => {
  const url = `${base()}/my/disputes`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const getMyDispute = async (disputeId) => {
  const url = `${base()}/my/disputes/${disputeId}`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const createDispute = async (payload) => {
  const url = `${base()}/disputes`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  Object.keys(payload).forEach(key => {
    if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
      params.append(key, payload[key])
    }
  })
  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const listAdminDisputes = async (params = {}) => {
  const url = `${base()}/disputes`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const getAdminDisputeById = async (disputeId) => {
  const url = `${base()}/disputes/${disputeId}`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message || 'Failed to fetch dispute' }
}

export const resolveDispute = async (disputeId, resolutionNotes) => {
  const url = `${base()}/disputes/${disputeId}/resolve`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  if (resolutionNotes) params.append('resolutionNotes', resolutionNotes)

  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

// TODO: Backend needs to implement this endpoint
export const addDisputeReply = async (disputeId, message) => {
  // This is a placeholder - backend needs to implement /v1/disputes/:disputeId/replies endpoint
  const url = `${base()}/disputes/${disputeId}/replies`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  params.append('message', message)

  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}
